import React, {useEffect} from "react";
import SectionContainer from "../layouts/SectionContainer";
import PresentationContainer from "../components/PresentationContainer";
import MemberList from "../components/MemberList";

const Company = () => {

  useEffect(() => {
    document.title = "L'entreprise Cartésia Junior";
  });

  const h =
    "Cartésia Junior est la junior entreprise de l’IUT de Paris. Spécialisée dans le développement de sites internet et de la communication web, Cartésia Junior proposera aux entreprises les services de ses étudiants pour créer leurs sites, alimenter leurs réseaux sociaux et mettre en place une communication associée à l’image de l’entreprise. L’entreprise offre également d’autres services tels que des études de marché … Actuellement, Cartésia est composée de 53 membres et l’entreprise ne cesse de s’agrandir. Les membres sont issus de toutes les filières de l’IUT telles que les filières: informatique, techniques de commercialisation, gestion des entreprises et administration pour finir la filière information de la communication. Le bureau comporte différents pôles à savoir : administration, communication, suivi de qualité, système informatique, évènementiel et commercial.";
  return (
    <div>
      <SectionContainer>
        <PresentationContainer title="Message du président" about={h} />
      </SectionContainer>
      <SectionContainer>
        <MemberList />
      </SectionContainer>
    </div>
  );
};

export default Company;
